import React, { Fragment } from "react"
import classnames from "classnames"
import styles from "./styles.css"

const ProductsPlantSkeleton = () => {
  const mainSectionClasses = classnames(
    styles.mainSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )

  const headerClasses = classnames(styles.header, styles.skeleton)
  const itemTableClasses = classnames(styles.skeleton)
  const itemsClasses = classnames(styles.itemsClasses)
  const itemValueClasses = classnames(styles.skeleton, styles.itemValue)

  return (
    <Fragment>
      <div className={mainSectionClasses}>
        <div className={headerClasses}></div>
        <table className={styles.table}>
          <thead className={styles.tableHeader}>
            <tr>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
              <th className={itemTableClasses}></th>
            </tr>
          </thead>

          <tbody className={styles.tableBody}>
            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>

            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>

            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>
            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>
            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>
            <tr className={itemsClasses}>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
              <th className={itemValueClasses}></th>
            </tr>
          </tbody>
        </table>
      </div>
    </Fragment>
  )
}

export default ProductsPlantSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/ProductsPlantSkeleton/index.js